export default __webpack_public_path__ + "static/media/c1.195d8011.svg";